import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatDialogRef, MAT_DIALOG_DATA, MatDialog, PageEvent } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { PedidoRecebimento } from 'src/app/models/pedido-recebimento';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PedidoRecebimentoService } from 'src/app/services/pedido-recebimento.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import swal from 'sweetalert2';
import { CadastrarPedidoRecebimentoModalComponent } from './cadastrar-pedido-recebimento-modal/cadastrar-pedido-recebimento-modal.component';
import { GlobalService } from 'src/app/services/global.service';
import { PaginatorService } from 'src/app/services/paginator.service';

declare const $: any;

@Component({
  selector: 'app-pedido-recebimento-modal',
  templateUrl: './pedido-recebimento-modal.component.html',
  styleUrls: ['./pedido-recebimento-modal.component.scss']
})
export class PedidoRecebimentoModalComponent implements OnInit {

  recebimentosFiltrados: PedidoRecebimento[] = [];
  carregando = true;
  campoOrdenacao = 'data';
  ordenarDesc = false;
  editavel = true;
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;
  valorTotalRecebimentos = 0;

  administrador = false;

  public config: PerfectScrollbarConfigInterface = {};

  podeEditarRecebimentos = false;
  idCupom;

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  constructor(
    private globalService: GlobalService, 
    public dialogRef: MatDialogRef<PedidoRecebimentoModalComponent>, 
    private carregandoService: CarregandoService, 
    public utilitarioService: UtilitarioService,
    private notificacaoService: NotificacaoService, 
    @Inject(MAT_DIALOG_DATA) public data: any, 
    public dialog: MatDialog, 
    private pedidoRecebimentoService: PedidoRecebimentoService,
    private paginatorService: PaginatorService
  ) {
    this.idCupom = data.idCupom;
    this.podeEditarRecebimentos = data.podeEditarRecebimentos;
  }

  async ngOnInit() {
    const pagination = this.paginatorService.consultarPaginacao();
    
    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.buscarPedidoRecebimento();

    this.administrador = await this.globalService.administrador();
  }

  buscarPedidoRecebimento() {
    this.carregandoService.mostra('buscarPedidoRecebimento');

    this.pedidoRecebimentoService.consultarRecebimentosComPaginacao(this.idCupom, this.paginacao.paginaAtual, this.itensPorPagina, this.campoOrdenacao, (this.ordenarDesc ? 'desc' : 'asc')).subscribe((data: any) => {
      this.recebimentosFiltrados = data.itens;

      if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
        this.itensPorPagina = 10;
      }

      this.paginacao.total = data.total;
      this.valorTotalRecebimentos = 0;
      this.recebimentosFiltrados.forEach(r => this.valorTotalRecebimentos += r.valor);

      this.carregando = false;
      this.carregandoService.esconde('buscarPedidoRecebimento');
    }, (erro) => {
      this.carregandoService.esconde('buscarPedidoRecebimento');
      this.notificacaoService.erro(erro);
    });
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarPedidoRecebimento();
  }

  fechar() {
    this.dialogRef.close();
  }

  excluirItem(idClass) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente excluir o Recebimento?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('excluirItem');
        this.pedidoRecebimentoService.excluir(idClass).subscribe(resp => {
          this.notificacaoService.sucesso('Recebimento excluído com sucesso!!!');
          this.carregandoService.esconde('excluirItem');
          this.buscarPedidoRecebimento();

        }, (erro) => {
          this.carregandoService.esconde('excluirItem');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }

  novoItem() {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(CadastrarPedidoRecebimentoModalComponent, {
      width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
      data: { idCupom: this.idCupom },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result: PedidoRecebimento) => {
      if (result) {
        this.buscarPedidoRecebimento();
      }
    });
  }

  editarItem(idClass) {
    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(CadastrarPedidoRecebimentoModalComponent, {
      width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
      data: { idCupom: this.idCupom, idPedidoRecebimento: idClass },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result: PedidoRecebimento) => {
      if (result) {
        this.buscarPedidoRecebimento();
      }
    });
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }
}